// extracted by mini-css-extract-plugin
module.exports = {"tile":"SelectableTile_tile__1Wtqi"};